import { render, staticRenderFns } from "./merchantsList.vue?vue&type=template&id=6413ce86&scoped=true"
import script from "./merchantsList.vue?vue&type=script&lang=ts"
export * from "./merchantsList.vue?vue&type=script&lang=ts"
import style0 from "./merchantsList.vue?vue&type=style&index=0&id=6413ce86&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6413ce86",
  null
  
)

export default component.exports